<template>
    <div class="unauthorized-container d-flex align-items-center justify-content-center">
        <img src="@/assets/pad-lock.svg" height="158px" class="object-fit-obtain" alt="">
        <div class="content d-flex flex-column">
            <h1>Unauthorized Access</h1>
            <span>Your account doesn’t have access to this page.</span>

            <div class="d-flex gap-10">
                <!-- <el-button @click="goToDashboard()" type="peiso-white-border-only" class="">Dashboard</el-button> -->
                <!-- <el-button type="peiso-primary-pink" class="">Upgrade to Peiso Pro</el-button> -->
                <el-button @click="goToDashboard()" type="peiso-primary-pink" class="">Dashboard</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                text: null,
            }
        },
        methods: {
            goToDashboard() {
                this.$router.push("/dashboard");
            }
        }
    }
</script>


<style lang='scss' scoped>
@import 'static/scss/fonts/fonts';
    .unauthorized-container {
        gap: 20px;
        background-color: $gray2;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        max-width: 717px;
        height: 285px;
        width: 100%;
        .content {
            max-width: 400px;
            gap: 10px;
            h1 {
                @include montserrat-font(36px, normal, 700, $white);
            }
            span {

                @include montserrat-font(18px, normal, 500, $white);
                margin-bottom: 10px;
            }
            .el-button--peiso-primary-pink, .el-button--peiso-white-border-only {
                @include montserrat-font(16px, normal, 700, $white) {
                    height: 54px;
                    max-width: 278px;
                    padding: 10px 1.5rem;
                    display: flex;
                    align-items: center;
                    border-radius: 10px;

                    &:hover {
                        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
                    }
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/card/unauthorized.vue